import {
  ConfirmationPopup,
  IconButton,
  LinkIconButton,
  useToast,
} from "@themis/ui";
import React, { useState } from "react";
import { PiPencilSimpleLineBold, PiTrashSimpleBold } from "react-icons/pi";
import { useParams, useRouteMatch } from "react-router-dom";

import { useDeleteContact } from "@/api/queries/contacts";

export function ContactsActionsCell({ contactId }: { contactId: number }) {
  const { url } = useRouteMatch();

  const toast = useToast();
  const { accountId } = useParams<{
    accountId: string;
  }>();
  const { mutate: deleteContact } = useDeleteContact({
    accountId: Number(accountId),
    onSuccess: () => {
      toast({
        content: "Contact has been removed!",
        variant: "success",
      });
    },
    onError: () => {
      toast({
        content: "Failed to remove contact!",
        variant: "error",
      });
    },
  });

  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  function handleDelete() {
    setIsConfirmationOpen(false);
    deleteContact(contactId);
  }

  function handleClickDelete() {
    setIsConfirmationOpen(true);
  }

  function handleCancelDelete() {
    setIsConfirmationOpen(false);
  }

  return (
    <>
      <LinkIconButton
        to={`${url}/${contactId}`}
        Icon={PiPencilSimpleLineBold}
        size="lg"
        color="tertiary"
      />
      <ConfirmationPopup
        anchor
        align="end"
        title="Delete Contact"
        content="Actions are non-reversible. Are you sure you want to proceed?"
        open={isConfirmationOpen}
        onCancel={handleCancelDelete}
        onConfirm={handleDelete}
      >
        <IconButton
          Icon={PiTrashSimpleBold}
          size="lg"
          color="tertiary"
          onClick={handleClickDelete}
        />
      </ConfirmationPopup>
    </>
  );
}
